// mock 测试数据

export default {
  data: {
    message: 'success',
    data: {
      total: 193,
      list: [
        {
          id: 1,
          options: {
            cover: require('../../../../public/static/marathon/videoCover.jpg'),
          },
          videoName: '监控1',
        },
        {
          id: 2,
          options: {
            cover: require('../../../../public/static/marathon/videoCover.jpg'),
          },
          videoName: '监控2',
        },
        {
          id: 3,
          options: {
            cover: require('../../../../public/static/marathon/videoCover.jpg'),
          },
          videoName: '监控3',
        },
        {
          id: 4,
          options: {
            cover: require('../../../../public/static/marathon/videoCover.jpg'),
          },
          videoName: '监控4',
        },
      ],
      pageNum: 1,
      pageSize: 20,
      size: 20,
      startRow: 1,
      endRow: 20,
      pages: 10,
      prePage: 0,
      nextPage: 2,
      isFirstPage: true,
      isLastPage: false,
      hasPreviousPage: false,
      hasNextPage: true,
      navigatePages: 8,
      navigatepageNums: [1, 2, 3, 4, 5, 6, 7, 8],
      navigateFirstPage: 1,
      navigateLastPage: 8,
    },
    status: 0,
  },
}
